import React from "react";
import { Modal, Button, Typography, Space, Alert } from "antd";
import { CrownOutlined, ArrowRightOutlined, CheckCircleOutlined, CloseOutlined, MessageOutlined, ShareAltOutlined, UserAddOutlined, FileTextOutlined, MoreOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Text, Title, Paragraph } = Typography;

const UpgradeDialog = ({
  visible,
  onClose,
  feature = "this feature",
}) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    if (onClose) onClose();
    navigate('/settings?tab=billing-usage');
  };

  const features = [
    { text: "Manage Conversation Topics", icon: <MessageOutlined /> },
    { text: "Social Media Integration", icon: <ShareAltOutlined /> },
    { text: "Add Team Members", icon: <UserAddOutlined /> },
    { text: "Higher Document Processing Limits", icon: <FileTextOutlined /> },
    { text: "and many more features.", icon: <MoreOutlined /> },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      closeIcon={null}
      width={520}
      styles={{
        body: { padding: 0 }
      }}
    >
      {/* Header Section with Gradient */}
      <div
        style={{
          background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
          padding: '40px 32px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Decorative circles */}
        <div style={{
          position: 'absolute',
          top: '-20px',
          right: '-20px',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.1)',
        }} />
        <div style={{
          position: 'absolute',
          bottom: '-30px',
          left: '-30px',
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.08)',
        }} />

        {/* Crown Icon */}
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            border: '3px solid rgba(255, 255, 255, 0.3)',
            position: 'relative',
            zIndex: 1
          }}
        >
          <CrownOutlined style={{ fontSize: 40, color: '#fff' }} />
        </div>

        {/* Title */}
        <Title level={2} style={{ color: '#fff', marginBottom: 8, fontWeight: 700, position: 'relative', zIndex: 1 }}>
          Upgrade Your Plan
        </Title>
{/*         
        <Text style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: 15, position: 'relative', zIndex: 1 }}>
          Unlock unlimited potential
        </Text> */}
      </div>

      <Alert
        message={`${feature} is only available in paid plans.`}
        // description=" "
        type="warning"
        showIcon
        style={{ marginBottom: 8, borderRadius: 8, marginTop: 32, fontSize: 16 }}
      />
      {/* Content Section */}
      <div style={{ padding: '32px' }}>
        {/* Feature Restriction Message */}

        {/* Feature List */}
        <div style={{ marginBottom: 32 }}>
          <Text strong style={{ fontSize: 16, color: '#262626', display: 'block', marginBottom: 16 }}>
            What you'll get:
          </Text>
          <Space direction="vertical" size={8} style={{ width: '100%' }}>
            {features.map((feature, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '4px 0 4px 20px',
                }}
              >
                {/* Icon */}
                <div
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: '#1890ff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  {React.cloneElement(feature.icon, { style: { fontSize: 10, color: '#fff' } })}
                </div>
                
                {/* Text */}
                <Text style={{ color: '#262626', fontSize: 14, flex: 1 }}>{feature.text}</Text>
              </div>
            ))}
          </Space>
        </div>

        {/* Action Buttons */}
        <Space direction="vertical" style={{ width: '100%' }} size={12}>
          <Button
            type="primary"
            size="large"
            onClick={handleUpgrade}
            style={{
              width: '100%',
              height: 52,
              fontSize: 16,
              fontWeight: 600,
              background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
              border: 'none',
              boxShadow: '0 4px 16px rgba(24, 144, 255, 0.4)',
              borderRadius: 8
            }}
            icon={<ArrowRightOutlined />}
            iconPosition="end"
          >
            View Plans & Upgrade
          </Button>
          
          <Button
            size="large"
            onClick={onClose}
            style={{
              width: '100%',
              height: 52,
              fontSize: 15,
              color: '#595959',
              border: 'none',
              background: 'transparent',
              fontWeight: 500
            }}
          >
            Not now
          </Button>
        </Space>

        {/* Trust Badge */}
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Text style={{ fontSize: 12, color: '#8c8c8c' }}>
            🔒 Secure payment • No hidden fees
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export default UpgradeDialog;